/*
  NINI nyelvvaltas - a kivalasztott nyelv egyertelmu, nativ bekuldese.
  A development elonezet azonositoja atiranyitas utan is megmarad.
  Keszitette: Akos | branch: dev/akos | 2026-10-09
  Modositva: Akos | branch: dev/akos | 2026-10-13 - nativ nyelvi linkek, query es dev elonezet megorzesevel.
*/
(() => {
  if (window.__niniLocalizationReady) return;
  window.__niniLocalizationReady = true;

  function prepareLanguageLink(link) {
    const language = link.dataset.niniLanguageLink;
    const alternates = [...document.head.querySelectorAll('link[rel~="alternate"][hreflang]')];
    const code = language.toLowerCase();
    const alternate = alternates.find(item => item.hreflang.toLowerCase() === code)
      || alternates.find(item => item.hreflang.toLowerCase().startsWith(`${code}-`));
    // Shopify's alternate URL also includes a translated product/page handle.
    // The Liquid href remains a working fallback before JavaScript loads.
    const destination = new URL(alternate?.href || link.href, location.origin);
    if (destination.origin !== location.origin) return;
    destination.search = location.search;
    destination.searchParams.delete('locale');
    destination.searchParams.delete('language_code');
    destination.hash = location.hash;
    const theme = window.Shopify?.theme;
    if (theme && ['development', 'unpublished'].includes(theme.role) && /^\d+$/.test(String(theme.id))) {
      destination.searchParams.set('preview_theme_id', String(theme.id));
    }
    link.href = destination.href;
  }

  function prepareLanguageLinks() {
    document.querySelectorAll('[data-nini-language-link]').forEach(prepareLanguageLink);
  }
  prepareLanguageLinks();
  document.addEventListener('shopify:section:load', prepareLanguageLinks);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const selector = event.target.closest?.('.nini-language-selector[open]');
    if (!selector) return;
    selector.open = false;
    selector.querySelector('summary')?.focus();
  });

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.nini-language-selector[open]').forEach(selector => {
      if (!selector.contains(event.target)) selector.open = false;
    });
    const link = event.target.closest?.('[data-nini-language-link]');
    if (link) {
      prepareLanguageLink(link);
      // Keep normal link navigation (including modifier keys / new tabs).
      // Apps must not turn this explicit language choice into an AJAX submit.
      event.stopImmediatePropagation();
      return;
    }

    // Compatibility for older form markup already open in the Theme Editor.
    const button = event.target.closest?.('button[name="language_code"]');
    const form = button?.form;
    if (!button || !form?.matches('.nini-localization, .footer__cross-border')) return;
    if (form.querySelector('input[name="form_type"]')?.value !== 'localization') return;
    const language = button.value;
    if (!language) return;

    event.preventDefault();
    // Native form.submit() does not serialize the clicked button. Put the
    // selected value in one hidden field instead, including on Safari/iOS.
    form.querySelectorAll('input[name="language_code"], input[name="locale_code"]').forEach((input) => input.remove());
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'language_code';
    input.value = language;
    form.append(input);

    const theme = window.Shopify?.theme;
    if (theme && ['development', 'unpublished'].includes(theme.role) && /^\d+$/.test(String(theme.id))) {
      let returnInput = form.querySelector('input[name="return_to"]');
      const destination = new URL(returnInput?.value || location.pathname + location.search, location.origin);
      if (destination.origin === location.origin) {
        destination.searchParams.set('preview_theme_id', String(theme.id));
        if (!returnInput) {
          returnInput = document.createElement('input');
          returnInput.type = 'hidden';
          returnInput.name = 'return_to';
          form.append(returnInput);
        }
        returnInput.value = destination.pathname + destination.search + destination.hash;
      }
    }

    // Use a full Shopify localization navigation, not an app's AJAX submit
    // interception which can leave the old language document on screen.
    HTMLFormElement.prototype.submit.call(form);
  }, true);
})();
